import { getChannels } from '../../services/api/channel.api';
import { GET_CHANNEL_LIST_REQUEST, GET_CHANNEL_LIST_SUCCESS, GET_CHANNEL_LIST_FAILURE } from '../types';
import { transformChannels } from '../../transforms/channel';
import { transformPagination } from '../../transforms/pagination';
import { transformError } from '../../transforms/error';
import { mapTable } from '../../helpers/table';
import { filterCaseClub } from '../../helpers/filter';

export default {
	namespaced: true,

	state: {
		isLoading: false,
		error: null,
		data: transformChannels([]),
		pagination: transformPagination({}),
	},

	getters: {
		tableData: (state) => mapTable(state.data, {
			// left side is transform keys, right side is table field keys
			id: 'id',
			name: 'name',
			slug: 'slug',
			type: 'type',
			updatedAt: 'updated_at',
		}),
		channelOptions: (state) => {
			// const channel = {
			// 	name: 'All channels',
			// 	value: null,
			// };
			const channels = state.data.map((item) => {
				return {
					name: item.name,
					value: item.id,
				};
			});

			return channels;
		},
	},

	mutations: {
		[GET_CHANNEL_LIST_REQUEST](state) {
			state.isLoading = true;
			state.error = null;
			state.data = [];
		},
		[GET_CHANNEL_LIST_SUCCESS](state, { data, meta }) {
			state.isLoading = false;
			const caseclub = data.filter((item) => filterCaseClub(item.slug));
			state.data = transformChannels(caseclub);
			state.pagination = transformPagination(meta);
		},
		[GET_CHANNEL_LIST_FAILURE](state, error) {
			state.isLoading = false;
			state.error = transformError(error);
		},
	},

	actions: {
		async getChannels({ commit }) {
			try {
				commit(GET_CHANNEL_LIST_REQUEST);
				const { data } = await getChannels();
				commit(GET_CHANNEL_LIST_SUCCESS, data);
			} catch (error) {
				commit(GET_CHANNEL_LIST_FAILURE, error);
			}
		},
	},
};
